export function replayShadowBackend(
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
glassEasel, context, element, handlers) {
    const createChildren = (elem, ownerShadowRoot) => elem.childNodes.map((child) => recv(child, ownerShadowRoot));
    const insertChildren = (be, children) => {
        if (children.length >= 5) {
            const frag = context.createFragment();
            children.forEach((child) => {
                frag.appendChild(child);
            });
            be.spliceAppend(frag);
            frag.release();
        }
        else {
            children.forEach((child) => {
                be.appendChild(child);
            });
        }
    };
    const setAttributes = (elem, be) => {
        if (elem.id)
            be.setId(elem.id);
        if (elem.classList) {
            const classNames = elem.classList.getClassNames();
            if (classNames)
                classNames.split(' ').forEach((className) => be.addClass(className));
        }
        elem.getNodeStyleSegments().forEach((style, index) => {
            if (style)
                be.setStyle(style, index);
        });
        elem.attributes.forEach(({ name, value }) => {
            be.setAttribute(name, value);
        });
        const dataset = elem.dataset;
        Object.keys(dataset).forEach((key) => {
            be.setDataset(key, dataset[key]);
        });
        const listeners = elem.getListeners();
        Object.keys(listeners).forEach((name) => {
            let mutLevel;
            let captureMutLevel;
            listeners[name].forEach(({ mutated, final, capture }) => {
                // eslint-disable-next-line no-nested-ternary
                const currentMutLevel = final
                    ? 2 /* glassEasel.EventMutLevel.Final */
                    : mutated
                        ? 1 /* glassEasel.EventMutLevel.Mut */
                        : 0 /* glassEasel.EventMutLevel.None */;
                if (capture) {
                    captureMutLevel =
                        captureMutLevel !== undefined && currentMutLevel < captureMutLevel
                            ? captureMutLevel
                            : currentMutLevel;
                }
                else {
                    mutLevel =
                        mutLevel !== undefined && currentMutLevel < mutLevel ? mutLevel : currentMutLevel;
                }
            });
            if (mutLevel !== undefined)
                be.setListenerStats(name, false, mutLevel);
            if (captureMutLevel !== undefined)
                be.setListenerStats(name, true, captureMutLevel);
        });
        const slotName = elem.slot;
        if (slotName)
            be.setSlot(slotName);
    };
    const setSlotName = (node, be) => {
        if (glassEasel.Element.isElement(node)) {
            const slotName = glassEasel.Element.getSlotName(node);
            if (slotName !== undefined)
                be.setSlotName(slotName);
        }
        const slotElement = glassEasel.Element.getSlotElement(node);
        if (slotElement)
            be.setSlotElement(backendElementMap.get(slotElement));
    };
    const backendElementMap = new Map();
    const recv = (elem, ownerShadowRoot) => {
        var _a, _b, _c, _d, _e;
        let be;
        if (glassEasel.TextNode.isTextNode(elem)) {
            be =
                ((_a = handlers.createElement) === null || _a === void 0 ? void 0 : _a.call(handlers, ownerShadowRoot, elem)) ||
                    ownerShadowRoot.createTextNode(elem.textContent);
            setSlotName(elem, be);
        }
        else if (glassEasel.NativeNode.isNativeNode(elem)) {
            be =
                ((_b = handlers.createElement) === null || _b === void 0 ? void 0 : _b.call(handlers, ownerShadowRoot, elem)) ||
                    ownerShadowRoot.createElement(elem.is, elem.stylingName);
            be.__wxElement = elem;
            be.associateValue(elem);
            setAttributes(elem, be);
            const listeners = elem.getModelBindingListeners();
            Object.keys(listeners).forEach((name) => {
                be.setModelBindingStat(name, listeners[name]);
            });
            insertChildren(be, createChildren(elem, ownerShadowRoot));
            setSlotName(elem, be);
        }
        else if (glassEasel.ShadowRoot.isShadowRoot(elem)) {
            be = ownerShadowRoot;
            be.__wxElement = elem;
            be.associateValue(elem);
            setAttributes(elem, be);
            insertChildren(be, createChildren(elem, ownerShadowRoot));
        }
        else if (glassEasel.VirtualNode.isVirtualNode(elem)) {
            be =
                ((_c = handlers.createElement) === null || _c === void 0 ? void 0 : _c.call(handlers, ownerShadowRoot, elem)) ||
                    ownerShadowRoot.createVirtualNode(elem.is);
            be.__wxElement = elem;
            be.associateValue(elem);
            if (elem.isInheritSlots()) {
                be.setInheritSlots();
            }
            setAttributes(elem, be);
            insertChildren(be, createChildren(elem, ownerShadowRoot));
            setSlotName(elem, be);
        }
        else if (glassEasel.Component.isComponent(elem)) {
            const options = elem.getComponentOptions();
            be =
                ((_d = handlers.createElement) === null || _d === void 0 ? void 0 : _d.call(handlers, ownerShadowRoot, elem)) ||
                    (() => {
                        var _a, _b;
                        const [styleScope, extraStyleScope] = elem.getStyleScopes();
                        return ownerShadowRoot.createComponent(elem.tagName, elem.isExternal(), elem.isVirtual(), styleScope !== null && styleScope !== void 0 ? styleScope : glassEasel.StyleScopeManager.globalScope(), extraStyleScope, Object.keys(elem.getExternalClasses()), (_b = (_a = elem.getShadowRoot()) === null || _a === void 0 ? void 0 : _a.getSlotMode()) !== null && _b !== void 0 ? _b : null, options.writeIdToDOM);
                    })();
            be.__wxElement = elem;
            be.associateValue(elem);
            setAttributes(elem, be);
            const externalClasses = elem.getExternalClasses();
            if (externalClasses) {
                Object.entries(externalClasses).forEach(([key, value]) => {
                    if (value)
                        be.setClassAlias(key, value);
                });
            }
            const shadowRoot = elem.getShadowRoot();
            if (shadowRoot) {
                const shadowRootBe = be.getShadowRoot();
                if (shadowRootBe) {
                    backendElementMap.set(shadowRoot, recv(shadowRoot, shadowRootBe));
                }
            }
            insertChildren(be, createChildren(elem, ownerShadowRoot));
            setSlotName(elem, be);
        }
        else {
            throw new Error(`Unknown elem type ${elem.constructor.name}`);
        }
        (_e = handlers.afterReplayElement) === null || _e === void 0 ? void 0 : _e.call(handlers, ownerShadowRoot, elem, be);
        backendElementMap.set(elem, be);
        return be;
    };
    const result = recv(element, context.getRootNode());
    backendElementMap.clear();
    return result;
}
//# sourceMappingURL=replay.js.map